import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIdxRates, saveIdxRatesBatch } from '../../api/idxRates';
import type { IdxRate } from '../../types/IdxRate';
import { t } from '../../i18n/t';

// "שערי מדדים" — current-snapshot rate data per index (Central).
// Natural PK idxId — editable only on Add. 3 rate columns, all FLOAT/nullable.
const columnDefs: ColDef<IdxRate>[] = [
  {
    field: 'idxId',
    headerName: t('idxRates.columns.idxId'),
    width: 130,
    editable: (params: EditableCallbackParams<IdxRate>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'baseRate',
    headerName: t('idxRates.columns.baseRate'),
    width: 160,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'openRate',
    headerName: t('idxRates.columns.openRate'),
    width: 160,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'currRate',
    headerName: t('idxRates.columns.currRate'),
    width: 160,
    editable: true,
    cellDataType: 'number',
  },
];

const newIdxRateDefaults = (): Partial<IdxRate> => ({
  idxId: 0,
  baseRate: null,
  openRate: null,
  currRate: null,
});

export function IdxRatesPage() {
  return (
    <LopCrudPage<IdxRate>
      resourceCode="idxRates"
      titleKey="idxRates.pageTitle"
      idField="idxId"
      getRows={getIdxRates}
      saveBatch={(added, modified, deletedIds) =>
        saveIdxRatesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newIdxRateDefaults}
    />
  );
}
